/**
 * Activity log row timestamp: "1 Feb, 2025 · 5:00 AM" (locale-aware).
 *
 * @param {string | null | undefined} iso
 * @param {string} [locale] i18n language (e.g. "en", "es")
 * @returns {string}
 */
export const formatAuditLogTimestamp = (iso, locale = 'en') => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    const loc = locale?.toLowerCase().startsWith('es') ? 'es' : 'en-GB';
    const datePart = d.toLocaleDateString(loc, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
    const timePart = d.toLocaleTimeString(loc, {
      hour: 'numeric',
      minute: '2-digit',
    });
    return `${datePart} · ${timePart}`;
  } catch {
    return '—';
  }
};
